import constantNum from "./constantNum"

const index = {
    install(Vue){
        Vue.component('constantNum',constantNum)
    }
};

export default index;
